import { render, staticRenderFns } from "./due-day-selection.vue?vue&type=template&id=ff5930b4&"
import script from "./due-day-selection.vue?vue&type=script&lang=js&"
export * from "./due-day-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports